export const AdminPostThreadController = {
    store(): void {},
};
